import React, { ChangeEvent, InputHTMLAttributes, useState } from "react"
import { Eye, EyeOff } from "lucide-react"
import "./LearnerField.style.scss"

type LearnerFieldProps = {
  id: string
  label: string
  name: string
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  type?: "text" | "email" | "password" | "date" | "number"
  placeholder?: string
  error?: string
  disabled?: boolean
  autoComplete?: string
  autoFocus?: boolean
} & Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "id" | "name" | "value" | "onChange" | "type" | "placeholder" | "disabled" | "autoComplete" | "autoFocus"
>

const LearnerField = ({
  id,
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder,
  error,
  disabled = false,
  autoComplete,
  autoFocus = false,
  ...rest
}: LearnerFieldProps) => {
  const [showPassword, setShowPassword] = useState(false)
  const isPassword = type === "password"
  const inputType = isPassword ? (showPassword ? "text" : "password") : type

  return (
    <div className="learner-field">
      <label htmlFor={id} className="learner-field__label">
        {label}
      </label>
      <div className={`learner-field__control ${isPassword ? "learner-field__control--password" : ""}`}>
        <input
          id={id}
          name={name}
          type={inputType}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          className={`learner-field__input ${error ? "is-error" : ""}`}
          aria-invalid={!!error}
          {...rest}
        />
        {isPassword && (
          <button
            type="button"
            className="learner-field__toggle"
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? "Hide password" : "Show password"}
            disabled={disabled}
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        )}
      </div>
      {error && <p className="learner-field__error">{error}</p>}
    </div>
  )
}

export default LearnerField
